<template>
  <transition name="fade" mode="out-in">
    <div class="screen-wrap">
      <v-app class="hmc-app">
        <v-main class="main-body">
          <v-container class="app-body">
            <div class="pe-2 ps-3 app-title text-h5">
              {{ $t("model.name.quests") }}
              <v-spacer></v-spacer>
              <CloseBtn size="40" :callback="exit" />
            </div>
              <!-- Main Tabs - Show after XP is loaded -->
              <v-tabs v-if="xpLoaded" v-model="activeTab" centered grow class="mb-4 rounded" style="overflow: hidden;" @change="onTabChange">
                <v-tab v-if="xp.currentLevel >= 3"> {{ $t("string.dailyQuestTab") }}</v-tab>
                <v-tab class="yellow">{{ $t("string.specialQuestTab") }}</v-tab>
              </v-tabs>
            <Loader v-if="!xpLoaded || api.isLoading || apiMission.isLoading || apiCompletedMission.isLoading" :isLoading="!xpLoaded || api.isLoading || apiMission.isLoading || apiCompletedMission.isLoading" />
            <div v-else class="px-5">

              <!-- Quest Tab Content -->
              <div v-if="activeTab === 0 && xp.currentLevel >= 3">
                <div class="subtitle text-center text-h5">
                  {{ $t("string.weekYear", { week: $moment().isoWeek(), year: $moment().year() }) }}
                </div>
                <div class="subtitle text-center mb-2">
                  {{ quests.length > 0 && quests[0].PlayerQuest.timestampClaimed ? $t("string.questMsg2") : $t("string.questMsg1") }}
                </div>
                <div class="text-center mb-4">
                  <CountDown :endTime="$moment().isoWeek($moment().isoWeek() + 1).startOf('isoWeek')"
                    :message="$t('string.resetIn')" />
                </div>

                <div v-for="quest in quests" :key="quest.key">
                  <v-card flat class="my-2 list-card-z">
                    <div class="d-flex flex-no-wrap align-center">
                      <div class="text-center mx-4 mt-2" v-for="(rwd, j) in quest.Reward" :key="j + 'qi'">
                        <div>
                          <v-img contain max-height="50" max-width="50" :src="rwd.Item.images.icon.url">
                          </v-img>
                          <div class="me-1">+{{ rwd.quantity }}</div>
                        </div>
                      </div>

                      <div style="width: 100%" class="pa-2">
                        <div class="text-h6">
                          {{ quest.name }}
                        </div>
                        <div class="d-flex flex-no-wrap align-center">
                          <div style="width: 100%" class="pe-3">
                            <v-progress-linear
                              :value="Math.min(loggedData.data.day, getDayFromKey(quest.key)) / getDayFromKey(quest.key) * 100"
                              color="green" height="20" rounded>
                              {{ Math.min(loggedData.data.day, getDayFromKey(quest.key)) }} /
                              {{ getDayFromKey(quest.key) }}</v-progress-linear>
                          </div>
                          <v-icon large v-if="quest.PlayerQuest.timestampClaimed" color="green">
                            mdi-check-circle
                          </v-icon>
                          <v-btn v-else-if="getDayFromKey(quest.key) <= loggedData.data.day" color="yellow"
                            class="text-h6 constant-tilt-shake" @click="claimQuest(quest)"
                            :loading="api.isLoading && selectedItem == quest">
                            {{ $t("action.claim") }}
                          </v-btn>
                          <v-btn v-else color="grey" dark depressed>
                            <v-icon> mdi-lock </v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </v-card>
                  <v-divider class="my-4" v-if="quest.key == 'QT_DAILY_COLLECT_DAY_7_LOGIN'"></v-divider>
                </div>
              </div>

              <!-- Mission Tab Content -->
              <div v-if="(xp.currentLevel >= 3 && activeTab === 1) || (xp.currentLevel < 3 && activeTab === 0)">
                <!-- Mission Sub-tabs -->
                <v-tabs v-model="missionSubTab" centered grow  background-color="transparent" class="mb-4">
                  <v-tab @click="setMissionSubTab('ongoing')">{{ $t("model.value.status.ongoing") }}</v-tab>
                  <v-tab @click="setMissionSubTab('completed')">{{ $t("string.completed") }}</v-tab>
                </v-tabs>

                <!-- Ongoing Missions -->
                <div v-if="missionSubTab === 0 && ongoingMissions.length > 0">
                  <v-card
                    v-for="(item, i) in ongoingMissions"
                    :key="'ongoing-' + i"
                    class="mb-3 bordered"
                    flat
                    outlined
                    @click="playMission(item)"
                  >
                    <v-card-text>
                      <div class="d-flex align-center">
                        <v-avatar color="brown" class="white--text mr-2" size="32">{{ i + 1 }}</v-avatar>
                        <div>
                          <div class="font-weight-medium text-body-1">
                            {{ item.questionName || '...' }}
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-center">
                        <div class="mr-2" style="width:32px;"></div>
                        <div>
                          <v-img
                            contain
                            max-width="35"
                            class="mx-auto"
                            :src="gradeShields[item.mathRecord && item.mathRecord.grade ? item.mathRecord.grade : 'X']"
                          ></v-img>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="mr-2">
                          <v-rating
                            :value="item.mathRecord.topStar"
                            background-color="amber"
                            color="amber"
                            length="3"
                            readonly
                            dense
                            size="18"
                          ></v-rating>
                        </div>
                        <div>
                          <v-btn
                            color="yellow"
                            rounded
                          >
                            <v-icon class="mr-1">mdi-play</v-icon>
                            {{ $t("action.play") }}
                          </v-btn>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Completed Missions -->
                <div v-if="missionSubTab === 1 && completedMissions.length > 0">
                  <v-card
                    v-for="(item, i) in completedMissions"
                    :key="'completed-' + i"
                    class="mb-3 bordered"
                    flat
                    outlined
                    @click="playMission(item)"
                  >
                    <v-card-text>
                      <div class="d-flex align-center">
                        <v-avatar size="32" color="success" class="white--text mr-2">
                          <v-icon color="white">mdi-check</v-icon>
                        </v-avatar>
                        <div>
                          <div class="font-weight-medium text-body-1">
                            {{ item.questionName || '...' }}
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-center">
                        <div class="mr-2" style="width:32px;"></div>
                        <div>
                          <v-img
                            contain
                            max-width="35"
                            class="mx-auto"
                            :src="gradeShields[item.mathRecord && item.mathRecord.grade ? item.mathRecord.grade : 'X']"
                          ></v-img>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="mr-2">
                          <v-rating
                            :value="item.mathRecord.topStar"
                            background-color="amber"
                            color="amber"
                            length="3"
                            readonly
                            dense
                            size="18"
                          ></v-rating>
                        </div>
                        <div>
                          <v-btn
                            color="default"
                            rounded
                            outlined
                          >
                            <v-icon class="mr-1">mdi-replay</v-icon>
                            {{ $t("action.playAgain") }}
                          </v-btn>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Empty states -->
                <div v-if="missionSubTab === 0 && ongoingMissions.length === 0" class="text-center mt-8">
                  <v-card flat class="mx-auto" style="max-width: 400px;">
                    <v-card-text class="pa-8 bordered">
                      <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-clipboard-list</v-icon>
                      <div class="text-h6 mb-2 text--secondary">{{ $t("string.missionsNotFound") }}</div>
                    </v-card-text>
                  </v-card>
                </div>

                <div v-if="missionSubTab === 1 && completedMissions.length === 0" class="text-center mt-8">
                  <v-card flat class="mx-auto" style="max-width: 400px;">
                    <v-card-text class="pa-8 bordered">
                      <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-check-circle</v-icon>
                      <div class="text-h6 mb-2 text--secondary">{{ $t("string.missionsNotFound") }}</div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
          </v-container>
        </v-main>
        <ApiErrorDialog v-if="api.isError" :api="api" />
        <ApiErrorDialog v-if="apiMission.isError" :api="apiMission" />
        <ApiErrorDialog v-if="apiCompletedMission.isError" :api="apiCompletedMission" />
        <RewardDialog v-if="rwdDialog" :callbackClose="() => (rwdDialog = false)" :showDialog="true"
          :rewards="rewards" />
      </v-app>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    RewardDialog: () =>
      import(
        /* webpackChunkName: "component-reward" */ "@/components/ABC/RewardDialog"
      ),
    CountDown: () =>
      import(
        /* webpackChunkName: "component-countdown" */ "@/components/CountDown.vue"
      ),
  },
  computed: {
    ...mapState({
      settings: (state) => state.settings.data,
      auth: (state) => state.auth.data,
    }),
    ongoingMissions() {
      return this.ongoingMissionsData.map(record => {
        const questionData = this.questionsData.find(q => q.key === record.questionKey);
        return {
          ...record,
          questionName: questionData ? questionData.name :  '......'
        };
      });
    },
    completedMissions() {
      return this.completedMissionsData.map(record => {
        const questionData = this.questionsData.find(q => q.key === record.questionKey);
        return {
          ...record,
          questionName: questionData ? questionData.name :  '......'
        };
      });
    },
  },
  props: [
    //
  ],
  data: () => ({
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    apiMission: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    apiCompletedMission: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    apiQuestion: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    xpLoaded: false,
    activeTab: 0,
    missionSubTab: 0,
    quests: [],
    missions: [],
    ongoingMissionsData: [],
    completedMissionsData: [],
    questionsData: [],
    loggedData: null,
    selectedItem: null,
    rwdDialog: false,
    rewards: [],
    xp: {
      currentLevel: 0,
      currentXp: 0,
      nextLevel: 0,
      nextXpThreshold: 1,
    },
    gradeShields: {
      A: require('@/assets/math/shields/gradeA.png'),
      B: require('@/assets/math/shields/gradeB.png'),
      C: require('@/assets/math/shields/gradeC.png'),
      F: require('@/assets/math/shields/gradeF.png'),
      X: require('@/assets/math/shields/gradeX.png')
    },
  }),
  async created() {
    await this.loadXP();
    
    // Set default tab from URL query after knowing the level
    const query = this.$route.query;
    
    if (this.xp.currentLevel >= 3) {
      // Two tabs available: Quest (0) and Mission (1)
      if (query.tab === 'mission') {
        this.activeTab = 1;
        if (query.subTab === 'completed') {
          this.missionSubTab = 1;
        }
        await this.getOngoingMissions();
        await this.getCompletedMissions();
      } else {
        // Default to quest tab
        this.activeTab = 0;
        await this.getQuest();
      }
    } else {
      // Only mission tab available at index 0
      this.activeTab = 0;
      if (query.subTab === 'completed') {
        this.missionSubTab = 1;
      }
      await this.getOngoingMissions();
      await this.getCompletedMissions();
    }
  },
  mounted() {
    //
  },
  methods: {
    exit() {
      this.$router.push({
        name: "PageWorldNews",
      });
    },
    claimQuest(item) {
      this.selectedItem = item;
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/quest/open";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.rewards = resp.Reward;
        this.rwdDialog = true;
        this.getQuest();
      };
      this.api.params = {
        key: item.key,
      };
      this.$api.fetch(this.api);
    },
    async getQuest() {
      this.quests = [];
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/quest/visit";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.quests = this.reorderQuests(resp.Quest);
        this.loggedData = resp.Save
        console.log(resp);

      };
      this.api.params = {
        model: "DailyLogin",
        modelKey: "DLQV01",
      };

      await this.$api.fetch(this.api);
    },
    async loadXP() {
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/xp/load";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        console.error(e);
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.xp = resp;
        this.xpLoaded = true;
      };
      await this.$api.fetch(this.api);
    },
    reorderQuests(quests) {
      // Extract the Day 7 quest
      const day7Quest = quests.find(q => q.key === "QT_DAILY_COLLECT_DAY_7_LOGIN");

      // Filter out Day 7 from the rest
      const otherDays = quests.filter(q => q.key !== "QT_DAILY_COLLECT_DAY_7_LOGIN");

      // Sort the remaining quests:
      // 1. By claimed status (null first)
      // 2. Then by day number extracted from the key
      const sortedOthers = otherDays.sort((a, b) => {
        const aClaimed = a.PlayerQuest?.timestampClaimed != null;
        const bClaimed = b.PlayerQuest?.timestampClaimed != null;

        if (aClaimed !== bClaimed) {
          return aClaimed ? 1 : -1; // Unclaimed first
        }

        const aDay = parseInt(a.key.match(/DAY_(\d+)_LOGIN/)[1]);
        const bDay = parseInt(b.key.match(/DAY_(\d+)_LOGIN/)[1]);

        return aDay - bDay;
      });

      // Return new array with Day 7 first
      return [day7Quest, ...sortedOthers];
    },

    getDayFromKey(key) {
      const match = key.match(/DAY_(\d+)_LOGIN/);
      return match ? parseInt(match[1], 10) : null;
    },
    setDefaultTabFromQuery() {
      const query = this.$route.query;
      
      // Set main tab based on query
      if (query.tab === 'mission') {
        // Mission tab will be index 1 if level >= 3, or index 0 if level < 3
        // This will be adjusted in created() after loading XP
        this.activeTab = 1;
        // Set mission sub-tab based on query
        if (query.subTab === 'completed') {
          this.missionSubTab = 1;
        } else {
          this.missionSubTab = 0; // Default to ongoing
        }
      } else if (query.tab === 'quest') {
        this.activeTab = 0; // Quest is always index 0 when it exists
      } else {
        // No query, default will be set in created() based on level
        this.activeTab = 0;
      }
    },
    onTabChange(tabIndex) {
      // Handle tab change based on level
      if (this.xp.currentLevel >= 3) {
        // Two tabs: Daily Quest (0) and Special Mission (1)
        if (tabIndex === 0) {
          // Daily Quest tab
          this.updateRoute({ tab: 'quest' });
          // Load quests if not already loaded
          if (this.quests.length === 0) {
            this.getQuest();
          }
        } else if (tabIndex === 1) {
          // Special Mission tab
          this.updateRoute({ tab: 'mission', subTab: this.missionSubTab === 1 ? 'completed' : 'ongoing' });
          // Load missions if not already loaded
          if (this.ongoingMissionsData.length === 0) {
            this.getOngoingMissions();
          }
          if (this.completedMissionsData.length === 0) {
            this.getCompletedMissions();
          }
        }
      } else {
        // One tab: Special Mission (0) - daily quest tab is hidden
        this.updateRoute({ tab: 'mission', subTab: this.missionSubTab === 1 ? 'completed' : 'ongoing' });
      }
    },
    async setActiveTab(tab) {
      if (tab === 'quest') {
        this.activeTab = 0;
        this.updateRoute({ tab: 'quest' });
      } else if (tab === 'mission') {
        this.activeTab = this.xp.currentLevel >= 3 ? 1 : 0;
        this.updateRoute({ tab: 'mission', subTab: this.missionSubTab === 1 ? 'completed' : 'ongoing' });
        
        // Load missions if not already loaded
        if (this.ongoingMissionsData.length === 0) {
          await this.getOngoingMissions();
        }
        if (this.completedMissionsData.length === 0) {
          await this.getCompletedMissions();
        }
      }
    },
    setMissionSubTab(subTab) {
      if (subTab === 'ongoing') {
        this.missionSubTab = 0;
        this.updateRoute({ tab: 'mission', subTab: 'ongoing' });
      } else if (subTab === 'completed') {
        this.missionSubTab = 1;
        this.updateRoute({ tab: 'mission', subTab: 'completed' });
      }
    },
    updateRoute(queryParams) {
      this.$router.replace({
        name: this.$route.name,
        query: queryParams
      }).catch(() => {}); // Ignore navigation duplicated error
    },
    async getOngoingMissions() {
      this.ongoingMissionsData = [];
      this.apiMission.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/mission/visit";
      this.apiMission.callbackReset = () => {
        this.apiMission.isLoading = true;
        this.apiMission.isError = false;
        this.apiMission.error = null;
      };
      this.apiMission.callbackError = (e) => {
        this.apiMission.isLoading = false;
        this.apiMission.isError = true;
        this.apiMission.error = e;
      };
      this.apiMission.callbackSuccess = async (resp) => {
        this.apiMission.isLoading = false;
        this.ongoingMissionsData = resp.Mission || [];
        await this.fetchQuestionNames();
      };
      await this.$api.fetch(this.apiMission);
    },
    async getCompletedMissions() {
      this.completedMissionsData = [];
      this.apiCompletedMission.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/mission/completed";
      this.apiCompletedMission.callbackReset = () => {
        this.apiCompletedMission.isLoading = true;
        this.apiCompletedMission.isError = false;
        this.apiCompletedMission.error = null;
      };
      this.apiCompletedMission.callbackError = (e) => {
        this.apiCompletedMission.isLoading = false;
        this.apiCompletedMission.isError = true;
        this.apiCompletedMission.error = e;
      };
      this.apiCompletedMission.callbackSuccess = async (resp) => {
        this.apiCompletedMission.isLoading = false;
        this.completedMissionsData = resp.Mission || [];
        await this.fetchQuestionNames();
      };
      await this.$api.fetch(this.apiCompletedMission);
    },
    playMission(mission) {
      this.$router.push({
        name: "PageMathGame",
        params: { topic: mission.questionKey,game:'NOGAME' },
      });
    },
    async fetchQuestionNames() {
      const allMissions = [...this.ongoingMissionsData, ...this.completedMissionsData];
      if (allMissions.length === 0) return;

      // Get unique question keys
      const questionKeys = [...new Set(allMissions.map(mission => mission.questionKey))];
      
      // Fetch question data for each key that we don't already have
      for (const key of questionKeys) {
        const existingQuestion = this.questionsData.find(q => q.key === key);
        if (!existingQuestion) {
          await this.fetchSingleQuestion(key);
        }
      }
    },
    async fetchSingleQuestion(questionKey) {
      this.apiQuestion.method = "post";
      this.apiQuestion.url = `${process.env.VUE_APP_URL_API_QUESTION}/v2/questions`;

      this.apiQuestion.callbackReset = () => {
        this.apiQuestion.isLoading = true;
        this.apiQuestion.isError = false;
        this.apiQuestion.error = null;
      };
      
      this.apiQuestion.callbackError = (e) => {
        this.apiQuestion.isLoading = false;
        this.apiQuestion.isError = true;
        this.apiQuestion.error = e;
        console.error('Error fetching question:', questionKey, e);
      };
      
      this.apiQuestion.callbackSuccess = (resp) => {
        this.apiQuestion.isLoading = false;
        if (resp && resp.length > 0) {
          this.questionsData.push(resp[0]);
        }
      };
      
      this.apiQuestion.params = {
        key: questionKey,
        lang: this.$_getLocale(),
        count: 1,
        showOption: true
      };
      
      await this.$api.fetch(this.apiQuestion);
    }
  },
};
</script>

<style scoped>
.subtitle {
  color: #4a3c31d7;
}

.app-title {
  z-index: 99;
  position: fixed;
  top: 0;
  max-width: 480px !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 5px 2px rgba(128, 128, 128, 0.5) !important;
  border: #caad87 5px solid;
  margin: auto;
  color: #fff;
  background-color: #f7efe3;
  text-shadow: #cbb18f 3px 0px 0px, #cbb18f 2.83487px 0.981584px 0px,
    #cbb18f 2.35766px 1.85511px 0px, #cbb18f 1.62091px 2.52441px 0px,
    #cbb18f 0.705713px 2.91581px 0px, #cbb18f -0.287171px 2.98622px 0px,
    #cbb18f -1.24844px 2.72789px 0px, #cbb18f -2.07227px 2.16926px 0px,
    #cbb18f -2.66798px 1.37182px 0px, #cbb18f -2.96998px 0.42336px 0px,
    #cbb18f -2.94502px -0.571704px 0px, #cbb18f -2.59586px -1.50383px 0px,
    #cbb18f -1.96093px -2.27041px 0px, #cbb18f -1.11013px -2.78704px 0px,
    #cbb18f -0.137119px -2.99686px 0px, #cbb18f 0.850987px -2.87677px 0px,
    #cbb18f 1.74541px -2.43999px 0px, #cbb18f 2.44769px -1.73459px 0px,
    #cbb18f 2.88051px -0.838247px 0px;
}

.text-stroke-sm {
  color: #fff;
  text-shadow: #8b5629 3px 0px 0px, #8b5629 2.83487px 0.981584px 0px,
    #8b5629 2.35766px 1.85511px 0px, #8b5629 1.62091px 2.52441px 0px,
    #8b5629 0.705713px 2.91581px 0px, #8b5629 -0.287171px 2.98622px 0px,
    #8b5629 -1.24844px 2.72789px 0px, #8b5629 -2.07227px 2.16926px 0px,
    #8b5629 -2.66798px 1.37182px 0px, #8b5629 -2.96998px 0.42336px 0px,
    #8b5629 -2.94502px -0.571704px 0px, #8b5629 -2.59586px -1.50383px 0px,
    #8b5629 -1.96093px -2.27041px 0px, #8b5629 -1.11013px -2.78704px 0px,
    #8b5629 -0.137119px -2.99686px 0px, #8b5629 0.850987px -2.87677px 0px,
    #8b5629 1.74541px -2.43999px 0px, #8b5629 2.44769px -1.73459px 0px,
    #8b5629 2.88051px -0.838247px 0px;
}

.main-body {
  /*background-color: #c7e5e9;*/
  background-color: rgba(214, 132, 49, 0.3);
}

.app-body {
  max-width: 480px;
  min-height: 100%;
  padding: 80px 0 40px 0;
  /* background-color: #f5dfc5; */
}

.list-card-z {
  padding: 5px !important;
  color: #785c3a !important;
  border-radius: 5px !important;
  border: #ccaf8b 4px solid !important;
  background-color: #fff9f1 !important;
  overflow-x: hidden !important;
}

.bordered {
  border: #ccaf8b 4px solid !important;
}

.constant-tilt-shake {
  animation: tilt-shaking 2s infinite;
}

.constant-tilt-shake:hover {
  animation: none;
}

@keyframes tilt-shaking {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }

  3% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  6% {
    transform: translate(0, 0) rotate(0eg);
  }

  9% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  12% {
    transform: translate(0, 0) rotate(0deg);
  }

  15% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  18% {
    transform: translate(0, 0) rotate(0eg);
  }

  21% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  24% {
    transform: translate(0, 0) rotate(0deg);
  }

  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}
</style>